import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NewsItem } from 'src/app/generated/CrossPoint.Sales.Server';


interface MessageData {
  contentHeight: number;
}

/*
  This is an example of the script that needs to be inserted into the news item HTML to provide the content height

  <script>
    window.addEventListener('load', () => {
      const postHeight = () => {
        const asInt = (value) => {
          const result = parseInt(value);
          return Number.isNaN(result) ? 0 : result;
        }
        const bodyStyle = window.getComputedStyle(document.body);
        let top = asInt(bodyStyle.marginTop);
        let bottom = asInt(bodyStyle.marginBottom);
        const element = document.querySelector('.news');
        const firstChild = element.firstElementChild;
        if (firstChild) {
          const firstChildStyle = window.getComputedStyle(firstChild);
          top += asInt(firstChildStyle.marginTop);
        }
        const lastChild = element.lastElementChild;
        if (lastChild) {
          const lastChildStyle = window.getComputedStyle(lastChild);
          bottom += asInt(lastChildStyle.marginBottom);
        }
        parent?.postMessage({ contentHeight: element.scrollHeight + top + bottom }, '*');
      };
      postHeight();
      window.addEventListener('resize', () => postHeight());
    });
  </script>

  Or minimized
  <script>window.addEventListener("load",(()=>{const t=()=>{const t=t=>{const e=parseInt(t);return Number.isNaN(e)?0:e},e=window.getComputedStyle(document.body);let n=t(e.marginTop),o=t(e.marginBottom);const i=document.querySelector(".news"),d=i.firstElementChild;if(d){n+=t(window.getComputedStyle(d).marginTop)}const s=i.lastElementChild;if(s){o+=t(window.getComputedStyle(s).marginBottom)}parent?.postMessage({contentHeight:i.scrollHeight+n+o},"*")};t(),window.addEventListener("resize",(()=>t()))}));</script>
*/

@Component({
  selector: 'xpac-article-item-content',
  templateUrl: './news-item-content.component.html',
  styleUrls: ['./news-item-content.component.scss']
})
export class NewsItemContentComponent implements OnInit, OnDestroy {

  public safeSrc: SafeResourceUrl;

  private eventFunc: (ev: MessageEvent<MessageData>) => void;
  private previousHeight: number = -1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public newsItem: NewsItem,
    public dialogRef: MatDialogRef<NewsItemContentComponent>,
    private sanitizer: DomSanitizer,
  ) {
  }

  public ngOnInit(): void {
    // Add an event listener to get the height from the iframe contents
    this.eventFunc = (ev: MessageEvent<MessageData>) => {
      const height: number = ev.data.contentHeight;
      this.updateIFrameHeight(height);
    };
    
    window.addEventListener('message', this.eventFunc);

    // Strip the 'language' query parameter, we don't need it
    const contentUrl: URL = new URL(this.newsItem.contentUrl);
    contentUrl.searchParams.delete('language');
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(contentUrl.toString());
  }

  public ngOnDestroy(): void {
    if (this.eventFunc) {
      window.removeEventListener('message', this.eventFunc);
      this.eventFunc = null;
    }
  }

  public onNoClick(): void {
    this.dialogRef.close(true);
  }

  private updateIFrameHeight(height: number, force: boolean = false): void {
    if (force || height !== this.previousHeight) {
      const iFrame: HTMLIFrameElement = document.querySelector('#myiframe');
      iFrame.style.height = `${height}px`;
      this.previousHeight = height;
    }
  }
}
